import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useQuery } from 'hooks'
import { DataTable, DataTablePagination } from 'components/common'
import { columns } from './utils'
import { fetchOrders } from 'utils/api/orderApi'
import { SetSelectedColumns } from 'types/dataTable'
import { RowClickedEvent } from '@ag-grid-community/core'
import { ORDER_TABLE_FIELDS, PAGE_ADMIN_ORDERS_DETAILS } from 'utils/constants'

type Props = {
  setSelectedColumns: SetSelectedColumns
  loading: boolean
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
}

const POLL_INTERVAL = 10000 // 10 seconds

const OrdersTable = ({ setSelectedColumns, loading, setLoading }: Props) => {
  const [ordersData, setOrdersData] = useState<any>({})

  const { search } = useLocation()
  const { getAllQueries } = useQuery()
  const navigate = useNavigate()

  const getOrders = async () => {
    setLoading(true)

    const { limit, search: SearchTerm, page, orderFilters } = getAllQueries()
    try {
      const { data } = await fetchOrders({
        limit: limit || 10,
        page: page || 1,
        search: SearchTerm,
        filters: orderFilters,
      })
      setSelectedColumns(data?.tableConfig?.order || [])
      setOrdersData({ ...data })
    } catch (error) {
      setOrdersData({ docs: [] })
    } finally {
      setLoading(false)
    }
  }

  const onRowClicked = (event: RowClickedEvent) => {
    navigate(
      `${PAGE_ADMIN_ORDERS_DETAILS.path}/${
        event.data[ORDER_TABLE_FIELDS.ORDER_NO.value]
      }`,
    )
  }

  useEffect(() => {
    getOrders()

    const intervalId = setInterval(() => {
      getOrders()
    }, POLL_INTERVAL)

    return () => clearInterval(intervalId)
  }, [search])

  return (
    <>
      <DataTable
        columns={loading ? [] : columns}
        rows={loading ? null : ordersData?.docs}
        identifier={ORDER_TABLE_FIELDS.ORDER_NO.value}
        onRowClicked={onRowClicked}
        activeColumnsKey="order"
        activeColumns={ordersData?.tableConfig?.order || []}
      />

      {/* Pagination */}
      <DataTablePagination
        disableGoToLastPage
        shouldDisplayTotalPages={false}
        currentPage={ordersData?.page}
        totalPages={ordersData?.totalPages}
        hasNextPage={ordersData?.hasNextPage}
        hasPrevPage={ordersData?.hasPrevPage}
        limit={ordersData?.limit}
        nextPage={ordersData?.nextPage}
        prevPage={ordersData?.prevPage}
      />
    </>
  )
}

export default OrdersTable
